<template>
  <div class="Container">
    <b-row
      ><b-col><h2>Flush Tracking Report</h2></b-col></b-row
    >
    <b-row
      ><b-col
        ><p class="explain">
          This report will show tracked flushes selected location over a certain
          time period.
        </p></b-col
      ></b-row
    >
    <hr />
    <b-row>
      <b-col>Select Time Period to show</b-col>
    </b-row>
    <b-row>
      <b-col cols="3"
        ><b-form-select
          v-model="selectedfilter"
          :options="filteroptions"
          class="mb-3"
          value-field="item"
          text-field="name"
        ></b-form-select
      ></b-col>
      <b-col
        ><b-button
          size="sm"
          variant="outline-secondary"
          v-on:click="applyfilter()"
          >Apply filter</b-button
        >
        <b-button
          size="sm"
          variant="outline-secondary"
          v-on:click="clearfilter()"
          >Clear filter</b-button
        ></b-col
      ></b-row
    >
    <!-- <hr /> -->
    <hr />
    <b-row class="text-center"
      ><b-col cols="1"></b-col><b-col><h4>Results</h4></b-col>
      <b-row
        ><b-col cols="1"
          ><img
            id="menuGraphic"
            align="right"
            src="../../assets/PDFIconSmall.png"
            v-on:click="createPDF()"/></b-col></b-row
    ></b-row>
    <br />
    <b-pagination
      v-model="currentPage"
      :total-rows="rows"
      :per-page="perPage"
    ></b-pagination>
    <b-table
      id="ResultsTable"
      :fields="this.fields"
      :items="this.reportvalues"
      :per-page="perPage"
      :current-page="currentPage"
      empty-text="There are no results for current filter"
      no-border-collapse
      hover
      show-empty
      responsive
      small
      class="text-center"
    >
    </b-table>

    <VueHtml2pdf
      :show-layout="false"
      :float-layout="true"
      :enable-download="true"
      :preview-modal="false"
      :paginate-elements-by-height="2400"
      :pdf-quality="2"
      :manual-pagination="true"
      pdf-format="a4"
      pdf-orientation="portrait"
      pdf-content-width="780px"
      :html-to-pdf-options="htmlToPdfOptions"
      ref="html2pdf"
    >
      <section slot="pdf-content">
        <b-row 
          ><b-col cols="8" align-self="center"><h3>Clarence Flush Tracking</h3></b-col><b-col cols="4">
            <img
               src="../../assets/LogoOnly.png"
              style="height:120px; margin: none; padding: none;"/></b-col
        ></b-row>
        <b-row class="text-left"><b-col cols="6"><h5>Location: {{ this.selectedlocation }}</h5></b-col></b-row>
        <b-row class="text-left"><b-col cols="6"><h5>Generated: {{ this.now }}</h5></b-col></b-row>
        <hr />
        <b-table
          id="ResultsTable"
          :fields="this.fields"
          :items="this.reportvalues"
          :per-page="perPage"
          :current-page="currentPage"
          empty-text="There are no results for current filter"
          no-border-collapse
          hover
          show-empty
          responsive
          small
          class="text-center"
        >
        </b-table>
        <hr />
        <b-row class="text-center"
          ><b-col>Generated from Seraph Protect</b-col></b-row
        >
      </section>
    </VueHtml2pdf>
  </div>
</template>

<script>
import axios from "axios";
import VueHtml2pdf from "vue-html2pdf";

export default {
  computed: {
    htmlToPdfOptions() {
      return {
        margin: 2,
        filename: "Flush Tracking Report.pdf",
        image: {
          type: "jpeg",
          quality: 0.98,
        },
        pagebreak: { mode: "avoid-all", after: ".avoidThisRow" },
      };
    },

    rows() {
      return this.reportvalues.length;
    },
  },

  components: {
    VueHtml2pdf,
  },

  data() {
    return {
      ReportReady: true,
      perPage: 15,
      currentPage: 1,
      selectedlocation: localStorage.getItem("CurrentLocation"),
      reportvalues: [],
      fields: [
        { key: "DeviceName", label: "Device" },
        { key: "RoomArea", label: "Room/Area" },
        // { key: "LocNote", label: "Location Note" },
        { key: "TestTimeDate", label: "Test Date & Time" },
        { key: "TestedBy", label: "Tested By" },
      ],
      now: null,
      selectedfilter: 7,
      filteroptions: [
        { item: "7", name: "1 Week" },
        { item: "14", name: "2 Weeks" },
        { item: "28", name: "4 Weeks" },

      ],
    };
  },

  async mounted() {
    this.ReportReady = false
    let LookUpUrl =
      "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
      this.$environment +
      "/reports";
    let LookUpHeaders = this.$apikeyPost;
    this.LookUpRequest = {
      Report: "device_manual_flushes",
      Location: this.selectedlocation,
      Filters: ["7"],
      RequestType: "",
      RequestVariable: "",
    };
    axios
      .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
      .then((response) => {
        let responsearray = response.data.Values;
        this.reportvalues = [];

        for (let i = 0; i < responsearray.length; i++) {
          this.reportvalues.push({
            DeviceName: responsearray[i][3],
            RoomArea: responsearray[i][4],

            TestTimeDate: responsearray[i][5] + " " + responsearray[i][6],
            TestedBy: responsearray[i][7],
          });
        }
        this.ReportReady = true
      });
  },

  methods: {
    createPDF() {
      let nowstamp = new Date();
      this.now = nowstamp.toLocaleString();
      this.$refs.html2pdf.generatePdf();
    },
    ReportLoaded() {
      if (this.ReportReady == true){
        this.$emit("ReportLoad", "Loaded");
      } else {
        this.$emit("ReportLoad", "Loading");
      }
    },
    applyfilter() {
      this.ReportReady = false
      let LookUpUrl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/reports";
      let LookUpHeaders = this.$apikeyPost;
      this.LookUpRequest = {
        Report: "device_manual_flushes",
        Location: this.selectedlocation,
        Filters: [this.selectedfilter],
        RequestType: "",
        RequestVariable: "",
      };
      axios
        .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
        .then((response) => {
          let responsearray = response.data.Values;
          this.reportvalues = [];

          for (let i = 0; i < responsearray.length; i++) {
            this.reportvalues.push({
              DeviceName: responsearray[i][3],
              RoomArea: responsearray[i][4],
              TestTimeDate: responsearray[i][5] + " " + responsearray[i][6],
              TestedBy: responsearray[i][7],
            });
          }
          this.ReportReady = true
        });
    },
    clearfilter() {
      this.selectedfilter = "7";
      this.ReportReady = false
      let LookUpUrl =
        "https://z4gvpjhmk4.execute-api.eu-west-2.amazonaws.com/" +
        this.$environment +
        "/reports";
      let LookUpHeaders = this.$apikeyPost;
      this.LookUpRequest = {
        Report: "device_manual_flushes",
        Location: this.selectedlocation,
        Filters: ["7"],
        RequestType: "",
        RequestVariable: "",
      };
      axios
        .post(LookUpUrl, this.LookUpRequest, LookUpHeaders)
        .then((response) => {
          let responsearray = response.data.Values;
          this.reportvalues = [];

          for (let i = 0; i < responsearray.length; i++) {
            this.reportvalues.push({
              DeviceName: responsearray[i][3],
              RoomArea: responsearray[i][4],

              TestTimeDate: responsearray[i][5] + " " + responsearray[i][6],
              TestedBy: responsearray[i][7],
            });
          }
          this.ReportReady = true
        });
    },
  },

  watch: {
    ReportReady() {
    this.ReportLoaded();
    }
  },
};
</script>

<style scoped>
p.explain {
  color: gray;
  font-size: small;
}
.pagination {
  font-size: small;
}
#menuGraphic {
  cursor: pointer;
}
</style>
